import React from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { LoadingIcon } from '@wwe-portal/ui/components/icons/loading-icon';
import { cn } from '@wwe-portal/ui/lib/lib';

interface ActiveSubsriptionButtonProps {
  onClick?: (event: React.SyntheticEvent) => void;
  active: boolean;
  subscribing: boolean;
  children?: React.ReactNode;
  isDisabled: boolean;
}

export function SubcribeButton({
  subscribing,
  onClick,
  active,
  children,
  isDisabled,
}: Readonly<ActiveSubsriptionButtonProps>) {
  return (
    <ClickableDiv
      className={cn(
        'text-text300 relative h-[40px] w-full select-none overflow-hidden rounded-md border border-solid bg-gradient-to-b from-[-75%] to-100% text-center text-lg font-bold hover:brightness-110 active:brightness-125',
        {
          'pointer-events-none': isDisabled,
        }
      )}
      data-theme="dark"
      onClick={onClick}
      style={{
        background:
          'linear-gradient(180deg, #FFA800 0%, #FFAD08 70.87%, #FFD153 134.99%)',
        border: '1px solid var(--white, #FFFFFF)',
      }}
    >
      <div className="absolute inset-0 flex items-center justify-center gap-4 bg-center text-white drop-shadow-[1px_1px_0.2px_rgba(0,0,0,0.7)]">
        {subscribing ? (
          <>
            <LoadingIcon />
            <span>Processing</span>
          </>
        ) : null}
        {!subscribing && !active && children}
        {!subscribing && children && active ? <span>MANAGE</span> : null}
      </div>
    </ClickableDiv>
  );
}
